import React, { useEffect } from "react";
import { Empty, Skeleton } from "antd";
import KitsDetailsCard from "../components/kits/kits-details-card/KitsDetailsCard";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, getKitList, getKitListClear } from "@src/redux/index";
import { useTranslation } from "react-i18next";

const Kits: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<AppDispatch>();
  const { result, loading } = useSelector(getKitList);

  useEffect(() => {
    dispatch(getKitListClear());
  }, []);

  const renderSkeleton = () => (
    <>
      {Array.from({ length: 4 }).map((_, idx) => (
        <div className="kit-card-wrapper" key={idx}>
          <div className="kit-card kit-card--skeleton">
            <div className="kit-accent" />
            <div className="kit-top">
              <div style={{ flex: 1, minWidth: 0 }}>
                <Skeleton
                  active
                  title={{ width: "30%" }}
                  paragraph={{ rows: 1, width: ["70%"] }}
                />
              </div>
            </div>
            <ul className="kit-devices">
              {Array.from({ length: 3 }).map((__, i) => (
                <li className="kit-device" key={i}>
                  <Skeleton.Avatar active size={28} shape="square" />
                  <div style={{ flex: 1, marginLeft: 10 }}>
                    <Skeleton
                      active
                      title={{ width: "40%" }}
                      paragraph={{ rows: 1, width: ["60%"] }}
                    />
                  </div>
                </li>
              ))}
            </ul>
          </div>
        </div>
      ))}
    </>
  );

  const hasKits = !loading && result?.items && result.items.length > 0;
  const isEmpty = !loading && result?.items && result.items.length === 0;

  return (
    <div className="kits-page-wrapper">
      <div className="kits-list-container">
        {loading && renderSkeleton()}
        {isEmpty && (
          <div className="kits-empty-wrapper">
            <Empty
              description={
                <span className="kits-empty-text">{t("kits_not_found")}</span>
              }
              className="kits_not_found"
            />
          </div>
        )}
        {hasKits &&
          result?.items?.map((kit: any) => (
            <KitsDetailsCard key={kit?.id} kit={kit} />
          ))}
      </div>
    </div>
  );
};

export default Kits;
